import Placement from './Placement'

export default Placement